import axios from 'axios';
const server = process.env.NODE_SERVER || 'prod';
const timeout = 30000;
const layout = 'adaptive';
const locale = 'ru-RU';

if (server !== 'prod') {
  console.info(`API url: ${process.env.API_URL}`);
  console.info(`ENV mode: ${process.env.NODE_MODE || 'remote'}`);
  console.info(`ENV server: ${server}`);
  console.dir({
    environment: process.env.VUE_ENV,
    timeout,
  })
}

const createFetcher = (token, baseURL = '/v3') => {
  // если импортим нодой прокидываем урл окружения в baseURL
  const Fetcher = axios.create({
    baseURL,
    timeout,
  });

  Fetcher.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${token}`;
    config.params = config.params || {};
    config.params.layout = config.params.layout || layout;
    config.params.locale = config.params.locale || locale;

    return config;
  }, Promise.reject);

  Fetcher.interceptors.response.use(
    (r = {}) => r.data || {},
    (e = {}) => {
      e.error = {};
      const errors = ((e.response || {}).data || {}).errors || {};
      if (errors) {
        // приведение ошибок бека к общему формату
        e.error = errors[0] || errors;
        delete e.response.data.errors;
      }
      return Promise.reject(e);
    },
  );

  return Fetcher;
}

export {
  createFetcher
}
